import { render } from "./VersesPanel.vue?vue&type=template&id=721515a7"
import script from "./VersesPanel.vue?vue&type=script&lang=js"
export * from "./VersesPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrewderse/Documents/repos/gal-scroll-viewer-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__